module.exports = __webpack_public_path__ + "media/applicants/instagram-5cd0c46b.svg";